import { createApp } from 'vue';
//import { createPinia } from 'pinia';
import App from './App.vue';
import router from './router/index.js';
import store from './stores/store.js'
import notifyPlugin from "@/plugins/notify";

import './assets/main.css'; // Tailwind
import './assets/buttons.scss';
import './assets/pills.scss';
import './assets/app.scss'
import '@vuepic/vue-datepicker/dist/main.css';

import 'leaflet/dist/leaflet.css'
import 'leaflet.markercluster/dist/MarkerCluster.css'
import 'leaflet.markercluster/dist/MarkerCluster.Default.css'

import './assets/my_leaflet.scss'

// PWA registration (optional in dev, autoUpdate in prod)
if ('serviceWorker' in navigator) {
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').catch(() => {});
  });
}

const app = createApp(App);
//app.use(createPinia());
app.use(store);
app.use(router);
app.use(notifyPlugin); // << aici bag plugin-ul meu de notify

// 🚀 învelește în funcție async
;(async () => {
  const auth = store.useAuthStore ? store.useAuthStore() : null
  if (auth) {
    await auth.autologin();
  }

  app.mount('#app');
})();